import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { SITE } from "../lib/site";

export const Footer = () => {
    return (
        <footer data-testid="site-footer" className="bg-forest text-bone mt-32 relative overflow-hidden grain-overlay">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
                <div className="md:col-span-5">
                    <div className="text-xs uppercase tracking-widest2 text-sand">{SITE.estd}</div>
                    <h3 className="font-serif text-4xl md:text-5xl mt-3 leading-tight">
                        {SITE.tagline}
                    </h3>
                    <p className="mt-6 text-bone/70 max-w-md leading-relaxed">
                        Premium PE wicker, synthetic rattan, and outdoor ropes for furniture brands and craftsmen who refuse to compromise.
                    </p>
                </div>

                <div className="md:col-span-3">
                    <div className="text-xs uppercase tracking-widest2 text-sand mb-5">Navigate</div>
                    <ul className="space-y-3">
                        {SITE.nav.map((n) => (
                            <li key={n.to}>
                                <Link
                                    to={n.to}
                                    data-testid={`footer-link-${n.label.toLowerCase()}`}
                                    className="text-bone/80 hover:text-sand transition-colors"
                                >
                                    {n.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <div className="text-xs uppercase tracking-widest2 text-sand mb-5">Reach Us</div>
                    <ul className="space-y-4 text-bone/80">
                        <li className="flex items-start gap-3">
                            <Mail size={16} className="mt-1 text-sand" />
                            <a href={`mailto:${SITE.email}`} className="underline-grow" data-testid="footer-email">{SITE.email}</a>
                        </li>
                        <li className="flex items-start gap-3">
                            <Phone size={16} className="mt-1 text-sand" />
                            <div className="flex flex-col">
                                <a href={`tel:${SITE.phone.replace(/\s/g, "")}`} className="underline-grow" data-testid="footer-phone">{SITE.phone}</a>
                                <a href={`tel:${SITE.phoneAlt.replace(/\s/g, "")}`} className="underline-grow" data-testid="footer-phone-alt">{SITE.phoneAlt}</a>
                            </div>
                        </li>
                        <li className="flex items-start gap-3">
                            <MapPin size={16} className="mt-1 text-sand" />
                            <span data-testid="footer-address">{SITE.address}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-bone/10">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-bone/60">
                    <div>© {new Date().getFullYear()} {SITE.legal}. All rights reserved.</div>
                    <div className="tracking-widest2 uppercase">Crafted with care · Made in India</div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
